import axios from 'axios';
import type { EmailNotificationInterval } from '@/models/emailNotificationInterval';
import HttpException from './HttpException';

class UserSetting {
    public async getAllEmailNotificationIntervals() {
        try {
            const response = await axios.get<EmailNotificationInterval[]>(
                '/userSettings/getAllEmailNotificationIntervals'
            );
            return response.data;
        } catch (error) {
            throw new HttpException(error.response.status, 'There was an error fetching the module by an id');
        }
    }

    public async updateUserEmailNotificationIntervals(emailNotificationInterval: EmailNotificationInterval) {
        try {
            const response = await axios.post('/userSettings/updateUserEmailNotificationIntervals', {
                id: emailNotificationInterval.id,
            });
            return response.data;
        } catch (error) {
            throw new HttpException(error.response.status, 'There was an error fetching the module by an id');
        }
    }

    public async toggleEmailNotifications() {
        try {
            const response = await axios.post('/userSettings/toggleEmailNotifications');
            return response.data;
        } catch (error) {
            throw new HttpException(error.response.status, 'There was an error fetching the module by an id');
        }
    }
}

export const userSettingWebservice = new UserSetting();
